// MULTI-TENANT FASE 4【1】— prefix path Storage per-toko (expand-contract mig 3120).
//
// Model: path TANPA prefix store = milik TOKO LEGACY (`stores.owns_legacy_storage`,
// galea) — nol pemindahan objek lama; toko lain WAJIB `<store_id>/…`. Prefix
// pemanggil diberikan server lewat RPC `storage_upload_prefix()`:
//   · toko legacy  → ""              (galea byte-identik dgn sebelum Fase 4)
//   · toko lain    → "<store_id>/"
//   · tak ter-resolve/error → ""     (fail-open ke bentuk legacy; policy
//     storage.objects tetap MENOLAK bila pemanggil bukan anggota toko legacy —
//     fail-closed di server, klien tinggal retry)
//
// SEMUA titik upload bucket `product-media` & `payment-proofs` wajib lewat
// `withStorePrefix(db, path)` — jangan merangkai path bucket secara langsung.

import type { SupabaseClient } from "@supabase/supabase-js";

// Cache per instance client (browser punya client per-scope admin/store; tiap
// sesi punya prefix sendiri). WeakMap → tak menahan client dari GC.
const prefixCache = new WeakMap<SupabaseClient, Promise<string>>();

async function fetchPrefix(db: SupabaseClient): Promise<string> {
  try {
    const { data, error } = await db.rpc("storage_upload_prefix");
    if (error) return "";
    return typeof data === "string" ? data : "";
  } catch {
    return "";
  }
}

/** Prefix storage toko pemanggil ("" utk toko legacy/galea, "<store_id>/" utk toko lain). */
export function storeStoragePrefix(db: SupabaseClient): Promise<string> {
  let cached = prefixCache.get(db);
  if (!cached) {
    cached = fetchPrefix(db);
    prefixCache.set(db, cached);
    // Jangan meng-cache kegagalan permanen: hasil "" karena error jaringan
    // boleh dicoba ulang pada upload berikutnya. Prefix "" yang SAH (toko
    // legacy) juga akan re-fetch — murah (satu RPC ringan per upload).
    cached.then((p) => {
      if (p === "") prefixCache.delete(db);
    });
  }
  return cached;
}

/** Bentuk path upload final: prefix toko + path relatif gaya lama. */
export async function withStorePrefix(
  db: SupabaseClient,
  path: string
): Promise<string> {
  const prefix = await storeStoragePrefix(db);
  return `${prefix}${path}`;
}
